<script lang="ts" setup>
const props = defineProps({
  data: Array
})
</script>

<template>
  <div class="review">
    <div class="review__intro">
      <Intro
        subtitle="review"
        :data="{
          title: '顧客好評'
        }"
        class="align-left display80"
      />
    </div>
    <div class="review__content">
      <ul class="review__lists">
        <li v-for="(item, index) in props.data" :key="index">
          <div class="review__lists__item">
            <div class="review__lists__text">{{ item.text }}</div>
            <div class="review__lists__author">{{ item.author }}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.review {
  @include grid;
  margin-bottom: toRem(210);
  @include max-media(990) {
    margin-bottom: toRem(90);
  }
  &__intro {
    grid-column: 1 / span 12;
  }
  &__content {
    grid-column: 4 / span 9;
    @include max-media(990) {
      grid-column: 1 / span 12;
    }
  }
  &__lists {
    @include grid(9, 24);
    grid-template-columns: repeat(auto-fill, calc((100% - 48px) / 3));
    @include max-media(767) {
      grid-template-columns: repeat(auto-fill, 100%);
    }
    &__item {
      position: relative;
      @include max-media(767) {
        margin-bottom: toRem(24);
      }
    }
    &__text {
      padding: toRem(60) toRem(24);
      border: 1px solid $color-gray-line;
      font-size: toRem(14);
      line-height: 1.3;
      // height: toRem(176);
      // @include dot-many-line(3);
      @include max-media(767) {
        width: calc(100% - toRem(50));
        min-height: toRem(130);
        margin-left: auto;
        padding: toRem(24) toRem(24) toRem(24) toRem(32);
      }
    }
    &__author {
      display: flex;
      align-items: center;
      justify-content: center;
      width: toRem(80);
      height: toRem(80);
      margin-top: toRem(-20);
      margin-left: toRem(20);
      background-color: $bg-1;
      border-radius: 50%;
      font-size: toRem(16);
      color: $color-gray-1;
      @include max-media(767) {
        position: absolute;
        left: 0;
        top: toRem(24);
        width: toRem(72);
        height: toRem(72);
        margin-left: 0;
        margin-top: 0;
      }
    }
  }
}
</style>
